import { render, staticRenderFns } from "./ReceiverWithFlag.vue?vue&type=template&id=7d410181&"
import script from "./ReceiverWithFlag.vue?vue&type=script&lang=js&"
export * from "./ReceiverWithFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports